module.exports = __webpack_public_path__ + "img/img5.0397e455.png";